import { gql } from '@apollo/client';

/**
 * Inspect whether a target URL can be embedded inside the social-player iframe.
 * Open-api proxies to the smallapp microservice tools endpoint
 * (`/api/tools/header-checker`) which fetches the URL and returns its
 * X-Frame-Options + CSP headers; the resolver applies the same allow/deny logic
 * as scio1's `advancedWebVIewModal.checkHeaderUrl()`.
 */
export const CHECK_URL_EMBEDDABLE = gql`
  query CheckUrlEmbeddable($url: String!) {
    checkUrlEmbeddable(url: $url) {
      canEmbed
      reason
      xFrameOptions
      csp
    }
  }
`;

export interface CheckUrlEmbeddableResult {
  checkUrlEmbeddable: {
    canEmbed: boolean;
    reason?: string | null;
    xFrameOptions?: string | null;
    csp?: string | null;
  };
}

export interface CheckUrlEmbeddableVariables {
  url: string;
}
